

const FontSize = {
  ExtraTiny: '10px',
  VeryTiny: '12px',
  Tiny: '14px',
  Small: '16px',
  Medium: '18px',
  Normal: '20px',
  Big: '24px',
  Large: '32px',
  Huge: '50px',
  Gigantic: '60px',
}

export default FontSize;